<template>
  <div class="project-set-members-wrap">
    <div class="top">
      <p>
        项目成员
        <span class="num">{{ num }}</span>
      </p>
    </div>
    <div class="operator">
      <el-input
        placeholder="搜索项目成员"
        v-model="keywords"
        @input="handleSearch"
        clearable
      >
        <i slot="prefix" class="icon iconfont iconicon_search1"></i>
      </el-input>
      <el-popover trigger="click" v-model="visible" v-if="addOrDelPermission">
        <ParticipantList
          v-if="visible"
          :taskMemberlist="taskMemberlist"
          v-model="taskMemberlistSelect"
          @confirm="handleConfirm"
          @close="handleClose"
        ></ParticipantList>
        <div class="add-btn" slot="reference">
          <i class="icon iconfont iconicon_enlarge"></i>
        </div>
      </el-popover>
    </div>

    <div class="members-con-wrap">
      <div class="members-con" v-if="Object.keys(membersDataList).length">
        <ul v-for="(value, key) in membersDataList" :key="key">
          <p class="tit">{{ key }}</p>
          <li v-for="item of value" :key="item.uid">
            <Myavatar
              width="28px"
              height="28px"
              fontSize="12px"
              :imgUrl="item.user_avatar"
              :userName="item.realname"
            >
              {{ item.realname }}
            </Myavatar>
            <span v-if="item.user_type === 2" class="admin">管理员</span>
            <el-dropdown v-if="(setAdminPermission || addOrDelPermission) && item.user_type !== 2" trigger="click" @command="handleCommand($event, item.uid)">
              <!-- <i class="icon iconfont iconicon_arrow_gantt_chart1 el-dropdown-link activeIconHover"></i> -->
              <div class="icon-wrap activeIconHover">
                <span class="icon"></span>
              </div>
              <el-dropdown-menu slot="dropdown" class="project-set-members-operation-dropdown">
                <!-- <el-dropdown-item command="common" :class="{'chos': !item.user_type}">普通成员</el-dropdown-item>
                <el-dropdown-item command="admin" :class="{'chos': item.user_type === 2}">项目管理员</el-dropdown-item> -->
                <el-dropdown-item v-if="setAdminPermission" command="admin">管理员</el-dropdown-item>
                <span class="line" v-if="setAdminPermission && addOrDelPermission"></span>
                <el-dropdown-item v-if="addOrDelPermission" command="delete" class="delete">移除成员</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul>
      </div>
      <nothing v-else :config="{ tip: '暂无此成员' }"></nothing>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';
//api
import api from '@/services/api/home/home'
//组件
import ParticipantList from './participantList.vue'

export default {
  props: {
    id: { // 项目id
      type: Number,
      default: 0
    },
    num: { // 成员数量
      type: Number,
      default: 0
    },
    isHide: { //该浮窗是否关闭
      type: Boolean,
      default: false
    },
    membersUidArr: { // 成员id组成的数组
      type: Array,
      default: []
    },
    membersDataList: { // 成员数据
      type: Object,
      default: {}
    },
    addOrDelPermission: { // 增/删成员权限
      type: Boolean,
      default: false
    },
    setAdminPermission: { // 设置管理员权限
      type: Boolean,
      default: false
    }
  },
  components: {
    ParticipantList
  },
  computed: {
    ...mapState('department/department', {
      departmentgroup: state => state.projectList.departmentgroup
    }),
    taskMemberlist () {
      let arr = []
      if (this.departmentgroup?.length) {
        const _list = this.departmentgroup
        for (let i = 0, len = _list.length; i < len; i++) {
          arr.push({
            value: _list[i].depart_id,
            label: _list[i].name,
            children: []
          })
          for (let j = 0, len2 = _list[i].member.length; j < len2; j++) {
            if (this.membersUidArr.indexOf(_list[i].member[j].uid) >= 0) {
              continue
            }
            arr[i].children.push({
              value: _list[i].member[j].uid,
              uid: _list[i].member[j].uid,
              label: _list[i].member[j].realname,
              realname: _list[i].member[j].realname,
              user_avatar: _list[i].member[j].user_avatar,
            })
          }
        }
      }
      return arr
    }
  },
  watch: {
    isHide (val) {
      if (val) {
        if (this.keywords) {
          this.keywords = ''
          this.$emit('handleSearchMember', '', false)
        }
      }
    },
    visible() {
      if (this.visible) {
        this.taskMemberlistSelect = []
      }
    }
  },
  data() {
    return {
      keywords: '',
      taskMemberlistSelect: [],
      visible: false
    }
  },
  methods: {
    //搜索
    handleSearch() {
      this.debounce(() => {
        this.$emit('handleSearchMember', this.keywords)
      }, 500)
    },
    //防抖函数
    debounce(fn, wait) {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(fn, wait)
    },
    async handleCommand(command, id) {
      let _api, _msg, param, needInit
      if (command === 'admin') {
        //设置成管理员
        this.handleSetAdmin(id)
      } else if (command === 'delete') {
        //删除成员
        this.handleDelete(id)
      }
    },
    async handleSetAdmin(id) {
      this.$wfAlert('', '确认更换此跨团队项目管理员？', '', '确定').then(async () => {
          const param = {
            id: this.id,
            member_admin: id
          }
          const res = await api.setCrossProjectsAdmin(param)
          if (res) {
            this.$message({
              message: '设置管理员成功',
              type: 'success'
            })
            this.$emit('handleSearchMember', '', false)
          }
        }).catch(() => {
          console.log('执行异常')
          next(false)
        })

    },
    async handleDelete(id) {
      this.$wfAlert('warning', '确认移除该成员?', '注意：该成员将同时被移出其所在的子项目。', '移除成员').then(async () => {
        const param = {
          id: this.id,
          project_members: [id]
        }
        const res = await api.delCrossProjectsMember(param)
        if (res) {
          this.$message({
            message: '已成功移除该成员',
            type: 'success'
          })
          this.$emit('handleSearchMember', '', true)
        }
      }).catch(() => {
        console.log('执行异常')
        next(false)
      })
    },
    // 添加新成员
    async handleConfirm(val) {
      const param = {
        id: this.id,
        project_members: val
      }
      const res = await api.addCrossProjectsMember(param)
      if (res) {
        this.$message({
          message: '添加成员成功',
          type: 'success'
        })
        this.$emit('handleSearchMember', '', true)
        this.visible = false
      }
    },
    // 添加成员弹框关闭
    handleClose() {
      this.visible = false
    }
  }
}
</script>

<style lang="scss">
.project-set-members-wrap {
  width: 314px;
  height: 672px;
  padding: 16px 0 8px;
  box-sizing: border-box;
  .top {
    font-size: 16px;
    font-weight: 500;
    color: #0D1F3C;
    line-height: 20px;
    padding: 0 16px;
    .num {
      font-size: 14px;
      font-weight: 400;
      color: rgba(13, 31, 60, .6);
      margin-left: 8px;
    }
  }
  .operator {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    margin: 24px 0 4px;
    .el-input__prefix {
      line-height: 40px;
      left: 16px;
    }
    .el-input {
      flex: 1;
      width: 0;
      input {
        height: 40px;
        padding-left: 38px;
        background: rgba(32, 32, 32, 0.04);
      }
    }
    .add-btn {
      cursor: pointer;
      width: 40px;
      height: 40px;
      background: linear-gradient(225deg, #1998F1 0%, #0D70E8 100%);
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 8px;
      &:hover {
        background: linear-gradient(225deg, #2fa9ff 0%, #1278eb 100%);
      }
      &:active {
        background: linear-gradient(225deg, #026ed8 0%, #0155ba 100%);
      }
      i {
        font-size: 13px;
        color: #fff;
      }
    }
  }
  .members-con {
    max-height: 556px;
    overflow-y: scroll;
    ul {
      .tit {
        font-size: 14px;
        color: rgba(13, 31, 60, .6);
        margin: 12px 0 8px 24px;
      }
      li {
        width: 100%;
        height: 40px;
        padding: 0 16px 0 24px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        cursor: pointer;
        position: relative;
        &:hover {
          background: rgba(32, 32, 32, 0.04);
          .icon-wrap {
            visibility: visible;
          }
        }
        &:active {
          background: #EAEBEC;
        }
        .avatar-box {
          .name-txt {
            margin-left: 16px;
            font-size: 14px;
            color: #0D1F3C;
          }
        }
        .admin {
          display: block;
          padding: 4px 8px 3px;
          background: #E6F1FF;
          border-radius: 4px;
          font-size: 12px;
          color: #2682FF;
          margin-left: 16px;
        }
        .el-dropdown {
          position: absolute;
          right: 16px;
          top: 50%;
          transform: translate(0, -50%);
        }
        // .icon-wrap {
        //   cursor: pointer;
        //   padding: 8px;
        //   visibility: hidden;
        //   &:hover {
        //     .icon {
        //       border-top: 6px solid rgba(38, 130, 255, 1);
        //     }
        //   }
        //   &:active {
        //     .icon {
        //       border-top: 6px solid rgba(38, 130, 255, .6);
        //     }
        //   }
        //   .icon {
        //     display: block;
        //     width: 0;
        //     height: 0;
        //     border-left: 4px solid transparent;
        //     border-right: 4px solid transparent;
        //     border-top: 6px solid rgba(13, 31, 60, .4);
        //   }
        // }
      }
    }
  }
  .nothing-box {
    img {
      width: 123px;
    }
  }
}
.project-set-members-operation-dropdown {
  .el-dropdown-menu__item {
    position: relative;
    width: 132px;
    box-sizing: border-box;
    &.chos {
      color: #2682FF;
      &::after {
        box-sizing: content-box;
        content: "";
        border: 1px solid #2682FF;
        border-left: 0;
        border-top: 0;
        width: 4px;
        height: 8px;
        position: absolute;
        right: 20px;
        top: 14px;
        transform: rotate(45deg) scaleY(1);
        transition: transform .15s ease-in .05s;
        transform-origin: center;
      }
    }
  }
  .line {
    display: block;
    width: 100%;
    height: 1px;
    background: #E7E9EC;
    margin: 4px 0;
  }
  .delete {
    color: #FF3939;
    &:hover {
      color: #FF3939;
      background: rgba(255, 57, 57, 0.08) !important;
    }
    &:active {
      color: #FF3939 !important;
      background: rgba(255, 57, 57, 0.16) !important;
    }
  }
}
</style>
